export default {
    GET: '@_get_help_data',
};
